<template>
<div class="">
    <el-table :data="pagedTableData" highlight-current-row height="500" :border="false"
                :stripe="false"
                :fit="true">
        <!--<el-table-column prop="code" label="Código"></el-table-column>-->
        <el-table-column label="Identificación" width="120">
            <template #default="scope">
                <div class="">
                    <span>{{scope.row.docName}}</span><br>
                    <span>{{scope.row.docnumber}}</span>
                </div>
            </template>
        </el-table-column>
        <el-table-column label="Participante" width="250">
            <template #default="scope">
                <div class="d-flex align-items-center">
                    <div class="symbol symbol-40 symbol-light-success mr-3">
                        <el-image class="border rounded" style="width: 40px; height: 40px" :src="scope.row.photo" :fit="'fill'"></el-image>
                    </div>
                    <div class="text-dark-50 text-hover-primary" style="line-height:1.25">
                        <span>{{scope.row.firstname}} </span><br>
                        <span> {{scope.row.lastname + ' ' + scope.row.surname}}</span>
                    </div>
                </div>
            </template>
        </el-table-column>

        <el-table-column prop="age" label="Edad" width="60">
        </el-table-column>
        <el-table-column prop="birthday" label="F. Nacimiento" width="120">
            <template #default="scope">
                <span>{{$moment(scope.row.birthday).format("DD/MM/YYYY")}}</span>
            </template>
        </el-table-column>
        <el-table-column label="Estado">
            <template #default="scope">
                <span class="badge badge-light-success" v-if="scope.row.mstatus == 1">Activo</span>
                <span class="badge badge-light-warning" v-if="scope.row.mstatus == 2">Baja temporal</span>
                <span class="badge badge-light-danger" v-if="scope.row.mstatus == 3">Baja definitiva</span>
            </template>
        </el-table-column>
        <el-table-column label="Opciones">
            <template #default="scope">
                <el-button type="primary" size="small" plain @click="setSelection(scope.row)">Seleccionar</el-button>
            </template>
        </el-table-column>

    </el-table>
    <el-pagination 
        class="mt-2"
        :current-page.sync="currentPage"
        :page-size="pageSize" 
        layout="total, prev, pager, next, jumper" 
        :total="list.length"
        @current-change="setPage">
    </el-pagination>
</div>
</template>

<script>
export default {
    props: {
        list: {
            require: true,
            type: Array,
            default: [],
        }
    },
    data: () => ({
        page: 1,
        pageSize: 5,
        currentPage: 1
    }),
    computed: {
        pagedTableData: function() {
            return this.list.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page)
        }
    },
    methods: {
        setPage (val) {
            this.page = val
        },
        setSelection(data) {
            this.$emit("getSelection", data);
        }
    }

}
</script>
